import { type IdTokenClaims, isIdTokenClaims } from './AuthTokenTypes';

export type JwtDecodeResult =
  | { ok: true; claims: IdTokenClaims }
  | { ok: false; error: string };

export function base64UrlDecodeToString(input: string): string {
  // Replace base64url chars with standard base64
  let base64 = input.replace(/-/g, '+').replace(/_/g, '/');
  // Pad to multiple of 4
  while (base64.length % 4 !== 0) {
    base64 += '=';
  }
  const binary = atob(base64);
  // Convert to UTF-8 string using TextDecoder approach via codePoints
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes);
}

export function decodeIdToken(idToken: string): JwtDecodeResult {
  const parts = idToken.split('.');
  if (parts.length < 2) {
    return { ok: false, error: 'Invalid JWT: expected at least 2 segments' };
  }
  try {
    const payloadStr = base64UrlDecodeToString(parts[1]);
    const parsed = JSON.parse(payloadStr) as unknown;
    if (!isIdTokenClaims(parsed)) {
      return { ok: false, error: 'JWT payload does not match expected IdTokenClaims shape' };
    }
    return { ok: true, claims: parsed };
  } catch (e) {
    return {
      ok: false,
      error: e instanceof Error ? e.message : 'Failed to decode JWT payload',
    };
  }
}
